import MainContainer, { AdsSettings } from "@container/MainContainer";
import WrapperBlock from "@container/WrapperBlock";
import { getGTMData } from "@helper/getGtmData";
import useGlobalAdSetting from "@hooks/useGlobalAdSetting";
import Quiz from "@modules/Quiz/Quiz";
import {
  fetchContext,
  ResponseType,
  TRouteWithRedirect,
} from "@sphtech/web2-core/ssr";
import { createMetaTags } from "@sphtech/web2-seo-schema";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";
import { ClientLoaderFunctionArgs } from "react-router";

import QuizMetaData from "./QuizMetaData";
const sectionName = "tamil-quiz";

export function meta() {
  return createMetaTags(QuizMetaData(sectionName).metaTags);
}

export default function QuizPage() {
  const pageAdTargetValue = PageAdTargetingTypeEnum.ARTICLE;
  const adSettings: AdsSettings = useGlobalAdSetting();
  return (
    <MainContainer
      sectionName={sectionName}
      pageAdTargetValue={pageAdTargetValue}
      suppliedAdsSettings={adSettings}
    >
      <WrapperBlock className="justify-between">
        <Quiz />
      </WrapperBlock>
    </MainContainer>
  );
}

export function loader(): Promise<TRouteWithRedirect<object | null, string>> {
  const { gaData } = QuizMetaData(sectionName);

  return Promise.resolve({
    type: ResponseType.SUCCESS,
    statusCode: 200,
    payload: null,
    gtm: getGTMData(gaData),
  });
}

export async function clientLoader(args: ClientLoaderFunctionArgs) {
  try {
    const result = (await fetchContext(args)) as { context?: unknown };
    if (result.context && typeof result.context === "object") {
      return result.context as TRouteWithRedirect<object | null, string>;
    }
  } catch (error) {
    console.warn("Client-side fetch failed, falling back to server loader");
  }
  return await args.serverLoader();
}
